import axios from "axios";

export default class BaseService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async fetch(path) {
    const response = await fetch(
      this.buildResoruce(path),
      this.generateHeaders()
    );

    return response.json();
  }

  post(path, body) {
    return axios.post(this.buildResoruce(path), body, this.generateHeaders());
  }

  patch(path, body) {
    return axios.patch(this.buildResoruce(path), body, this.generateHeaders());
  }

  buildResoruce(path) {
    return `${this.baseUrl}${path}`;
  }

  generateHeaders() {
    return {
      withCredentials: true,
      credentials: "include",
    };
  }

  download(path) {
    return axios({
      method: "get",
      url: this.buildResoruce(path),
      responseType: "blob",
      ...this.generateHeaders(),
    });
  }
}
